import React from 'react';
import { FormProvider as RHFForm } from 'react-hook-form';

export function Form({ children, onSubmit, onBlur, onChange, methods, style }) {
    return (
        <RHFForm {...methods}>
            <form
                onSubmit={onSubmit}
                onBlur={onBlur}
                onChange={onChange}
                noValidate
                autoComplete='off'
                style={style}
            >
                {children}
            </form>
        </RHFForm>
    );
}